var React = require('react');

function SortUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M41.05 288.05h238c21.4 0 32.1 25.9 17 41l-119 119a23.9 23.9 0 0 1-33.8.1l-.1-.1-119.1-119c-15.05-15.05-4.4-41 17-41z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M24.05 183.05l119.1-119A23.9 23.9 0 0 1 177 64a.94.94 0 0 1 .1.1l119 119c15.1 15.1 4.4 41-17 41h-238c-21.45-.05-32.1-25.95-17.05-41.05z","className":"fa-primary","key":2})]);
}

SortUp.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = SortUp;

SortUp.default = SortUp;
